<script>
import moment from "moment";

const momentTz = require('moment-timezone')

export default {
    name: "ChildAppearanceLog",
    props: {
        status: {
            type: Object,
            required: true
        },
        showDetails: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        statusIndicatorClass() {
            const map = {
                check_in: 'bg-green',
                check_out: 'bg-red',
                missing: 'bg-gray-800'
            }

            return map[this.status.type];
        },
        statusTime() {
            const date = new Date(this.status.created_at);

            return moment(date).format('LT');
        },
        statusUserName() {
            const user = this.status.parent ?? this.status.user;
            return user.name;
        },
        statusUserSurname() {
            const user = this.status.parent ?? this.status.user;
            return user.surname ? user.surname[0] + '.' : '';
        },
        isNotice() {
            return this.status.parent !== null;
        },
        additionalInfo() {
            return this.status.description;
        }
    }
}
</script>

<template>
    <div class="d-flex align-items-center gap-2">
        <span :class="['check_in_out_icon', statusIndicatorClass]"></span>
        <p class="fw-bold text-gray-1000 mb-0">{{ statusTime }}</p>
        <p class="mb-0 small text-gray-600">{{ statusUserName }} {{ statusUserSurname }}</p>
        <p class="mb-0" v-if="!showDetails && isNotice">
            <i class="fi fi-rr-envelope-dot d-flex"></i>
        </p>
        <p class="small mb-0 d-flex align-items-center gap-2" v-if="showDetails && additionalInfo">
            <i class="fi fi-rr-arrow-right"></i>
            <span>{{ additionalInfo }}</span>
        </p>
    </div>
</template>

<style scoped>

</style>
